import { styled } from '@mui/material'
import { ComponentProps } from 'react'

// Content styles for displaying stored rich-text HTML (previously from quill's snow stylesheet).
const StyledSpanWithQuillOverrides = styled('span')(({ theme: { palette, spacing, strokeWidth, typography } }) => ({
  '& ul': { listStyle: 'disc', paddingLeft: '1.5em', margin: '4px 0' },
  '& ol': { listStyle: 'decimal', paddingLeft: '1.5em', margin: '4px 0' },
  '& .tableWrapper': { overflowX: 'auto' },
  '& table': { borderCollapse: 'collapse', width: '100%', margin: spacing(1, 0) },
  '& th, & td': {
    border: `${strokeWidth.default} solid ${palette.border.subtle}`,
    padding: spacing(1.5, 2),
    verticalAlign: 'top',
    textAlign: 'left',
  },
  '& th': { ...typography['body-medium'], background: palette.bg.surface.subtle },
  // TipTap wraps cell content in <p>; without this the user-agent margins double the cell padding.
  '& th > p, & td > p': { margin: 0 },
  '& blockquote': {
    borderLeft: `4px solid ${palette.border.subtle}`,
    paddingLeft: '1em',
    margin: '4px 0',
    color: palette.text.default,
  },
  '& a': { color: palette.text.brand.default, textDecoration: 'underline' },
  '& img': { maxWidth: '100%', maxHeight: '320px', height: 'auto', objectFit: 'contain' },
  '& .mention': {
    color: palette.text.brand.default,
    background: palette.bg.brand.muted,
    padding: '1px 4px',
    borderRadius: '4px',
  },
  '& .mention[data-error="true"]': {
    color: palette.text.danger.onDangerMuted,
    background: palette.bg.danger.muted,
  },
}))

const StyledQuillEditor = styled('span')(() => ({}))

// Intentionally no `ql-editor` class — that selector is reserved for the editable input.
export const SpanWithQuillStyles = (props: ComponentProps<typeof StyledSpanWithQuillOverrides>) => {
  const { children, ...restProps } = props
  return (
    <StyledSpanWithQuillOverrides>
      <StyledQuillEditor {...restProps}>{children}</StyledQuillEditor>
    </StyledSpanWithQuillOverrides>
  )
}
